export default __webpack_public_path__ + "static/media/sourcecode.d9fc9376.svg";